export const applyHighlights = (text: string, highlights: string[]) => {
  let result = text;

  highlights.forEach((word) => {
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(escaped, "gi");
    result = result.replace(regex, `<span class="highlight">${word}</span>`);
  });

  return result;
};
